import {
  PT_FILTER_OUTLETS_PRODUCTS,
  PT_PROMO_PRODUCT_LIST,
  PT_PRODUCT_LIST,
  PT_PRODUCT,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  DIFERENCE_MINUTES,
  HEADER_TAB_SETUP,
} from "../../functions/funtion";
import {
  GET_SELECTED_MERCHANT_OR_PRODCUCT,
  GET_SET_STORED_DATA,
  GET_CART,
} from "../../database/get-stored-data";
import {
  set_dto_selected_merchant_or_product,
  set_dto_MobileAppCategory,
} from "../../classes/dto-setters/dto-setter";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  CSP,
} from "../../config/config";
import {
  Api_DrawAnalyticalPath,
  api_DaitonnAnalytical,
} from "../../connection/api/api-Machine-Learning";
import { api_CategoryPageLoadGroceryCategory } from "../../connection/api/api-grocery-category";
import { dto_selected_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_common } from "../../classes/dto-common";
import { isMobile } from "react-device-detect";
import { Colors } from "../../util/colors";
import { Font } from "../../util/config-fonts";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import CatPlaceholder from "./components/category-placeloader/Category-placeLoader";
import SummaryCart from "../../components/render-drawer-summary-cart/render-drawer-summary-cart";
import React from "react";
import "../../styles/css/fixedbutton.css";

export default class MasterCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IsLoading: false,
      Category: [],
      IsSummaryCart: false,
      LocalCart: [],
    };
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Category",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_HOME);
      },
      HeaderNavigatorMenuDisplay: true,
      FnHeaderNavigatorMenu: () => {
        this.props.navigate(
          PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "category")
        );
      },
    });
    await this.LoadMasterCategory();
    let cart = await GET_CART();
    if (cart !== undefined) {
      this.setState({ LocalCart: cart });
    }
    if (CSP === "MK" || CSP === "DT") {
      this.keepCheckInterval = setInterval(() => {
        this.keepCheck();
      }, 750);
    }
  }

  async keepCheck() {
    let cart = await GET_CART();
    if (cart !== undefined) {
      this.setState({ LocalCart: cart });
      return;
    }
  }

  async componentWillUnmount() {
    clearInterval(this.keepCheckInterval);
  }

  async LoadMasterCategory() {
    this.setState({ IsLoading: true });
    let dataStorage = ENCRYPT_STORAGE.getItem("MasterCategory");
    let data = "";
    if (
      dataStorage !== undefined &&
      dataStorage !== "" &&
      dataStorage.MID === dto_selected_merchant_or_product.MID
    ) {
      let StorageDateTime = new Date(dataStorage.date);
      let currentDateTime = new Date();
      let DifferenceMinute = DIFERENCE_MINUTES(
        currentDateTime,
        StorageDateTime
      );
      if (DifferenceMinute > 5) {
        data = await api_CategoryPageLoadGroceryCategory();
        ENCRYPT_STORAGE.setItem("MasterCategory", {
          data: data,
          date: new Date(),
          MID: dto_selected_merchant_or_product.MID,
        });
      } else {
        data = dataStorage.data;
      }
    } else {
      data = await api_CategoryPageLoadGroceryCategory();
      ENCRYPT_STORAGE.setItem("MasterCategory", {
        data: data,
        date: new Date(),
        MID: dto_selected_merchant_or_product.MID,
      });
    }

    let objData = JSON.parse(data);
    let Localcart = await GET_CART();
    if (Localcart === undefined) {
      Localcart = [];
    }
    setTimeout(() => {
      this.setState({
        IsLoading: false,
        Category: objData,
        LocalCart: Localcart,
      });
    }, 300);
    await api_DaitonnAnalytical();
  }

  getTotalPrice() {
    const total = this.state.LocalCart.reduce(
      (sum, item) => sum + item.Qty * item.UP,
      0
    );
    const formattedTotal = total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${dto_StartupPageLoadInfo.Currency} ${formattedTotal}`;
  }

  render() {
    return (
      <div
        style={{
          marginTop: 55,
          marginBottom: 55,
        }}
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        <>
          {this.state.IsLoading ? (
            <CatPlaceholder />
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginLeft: "10px",
                }}
              >
                {this.state.Category.map((item) => {
                  if (
                    item.CategoryImageUrl === "" ||
                    item.CategoryImageUrl === "N/A"
                  ) {
                    // item.CategoryImageUrl = "https://www.daitonnmail.com/images/DAITONN/1_1/MKB/PRODUCTS/MKBNull.png";
                    item.CategoryImageUrl = dto_common.DefaultImageUrl;
                  }
                  return (
                    <div
                      style={{
                        width: "33.33%",
                        padding: "0 4px",
                        cursor: "pointer",
                      }}
                      key={item.CATID + "MACCATE"}
                      onClick={() => {
                        ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                        this.NavigateToProduct(item);
                        set_dto_MobileAppCategory(item);
                      }}
                    >
                      <div style={{ padding: "2px" }}>
                        <img
                          src={item.CategoryImageUrl}
                          style={{ height: 100, width: 100 }}
                          onError={(e) => {
                            // e.currentTarget.src = "https://www.daitonnmail.com/images/DAITONN/1_1/MKB/PRODUCTS/MKBNull.png";
                             e.currentTarget.src = dto_common.DefaultImageUrl;
                          }}
                          alt=""
                        />
                        <p
                          style={{
                            width: 90,
                            fontSize: Font.Description,
                            marginTop: 0,
                          }}
                        >
                          {item.Category}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </>

        {/* Cart Icon For View Cart */}
        {/* {this.state.LocalCart.length > 0 && CSP !== "MK" && CSP !== "DT" ? (
          <button
            id="QuickCartBTN"
            style={{
              left: isMobile ? "80%" : "63%",
              backgroundColor: Colors.ThemeBGcolor,
            }}
            onClick={async () => {
              let Localcart = await GET_CART();
              if (Localcart === undefined) {
                Localcart = [];
              }

              this.setState(
                { IsSummaryCart: true, LocalCart: Localcart },
                async () => {
                  await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
                    let Localcart = await GET_CART();
                    if (Localcart === undefined) {
                      Localcart = [];
                    }
                    this.setState({
                      IsSummaryCart: false,
                      LocalCart: Localcart,
                    });
                  });
                }
              );
            }}
          >
            <i className="bi bi-cart4" style={{ fontSize: 28 }} />
          </button>
        ) : null} */}

        {/* View Basket For View Cart */}
        {this.state.LocalCart.length > 0 
        // && (CSP === "MK" || CSP === "DT") 
        ? (
          <button
            id="QuickCartBTN"
            style={{
              position: "fixed",
              background:
                "linear-gradient(135deg, rgb(46, 41, 41) 0%, rgb(83, 78, 78) 100%)",
              bottom: "52px",
              zIndex: 99,
              padding: "5px 6px 5px 16px",
              outline: "none",
              borderRadius: "100px",
              fontSize: 16,
              color: "white",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign: "left",
              whiteSpace: "nowrap",
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
              gap: "12px",
              minWidth: isMobile ? "calc(100% - 28px)" : "330px",
              maxWidth: isMobile ? "calc(100% - 28px)" : "360px",
              boxShadow: "0 12px 28px rgba(0, 0, 0, 0.22)",
              border: "1px solid rgba(255, 255, 255, 0.08)",
            }}
            onClick={async () => {
              let Localcart = await GET_CART();
              if (Localcart === undefined) {
                Localcart = [];
              }
              this.setState(
                { IsSummaryCart: true, LocalCart: Localcart },
                async () => {
                  await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
                    let Localcart = await GET_CART();
                    if (Localcart === undefined) {
                      Localcart = [];
                    }
                    this.setState({
                      IsSummaryCart: false,
                      LocalCart: Localcart,
                    });
                  });
                }
              );
            }}
          >
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: 1.1,
              }}
            >
              <span
                style={{
                  fontWeight: "700",
                  fontSize: "17px",
                }}
              >
                {this.state.LocalCart.length}{" "}
                {this.state.LocalCart.length === 1 ? "Item" : "Items"}
              </span>
            </span>
            <span
              style={{
                fontWeight: "700",
                padding: "6px 10px",
                borderRadius: "999px",
                backgroundColor: "rgba(255, 255, 255, 0.14)",
                border: "1px solid rgba(255,255,255,0.12)",
                fontSize: "15px",
                flexShrink: 0,
              }}
            >
              {this.getTotalPrice()}
            </span>
          </button>
        ) : null}

        <DrawerSheetBottom
          open={this.state.IsSummaryCart}
          element={
            <SummaryCart
              CartData={this.state.LocalCart}
              navigate={this.props.navigate}
              ItemClick={async (item) => {
                this.setState({ IsSummaryCart: false }, () => {
                  this.props.navigate(
                    PT_PRODUCT.replace(":frompage", "cart")
                      .replace(":navigatepage", "product-list")
                      .replace(":category", "category")
                      .replace(":pid", item.PID)
                      .replace(":lineid", item.LineID)
                      .replace(":adonlineid", item.ADDONLINEID)
                      .replace(":isrecommended", 0)
                  );
                });
              }}
              onCartUpdated={(updatedCart) => {
                this.setState({ LocalCart: updatedCart });
              }}
              closeFunction={() => this.setState({ IsSummaryCart: false })}
            />
          }
          size={isMobile ? "85%" : 280}
          Heading="Shopping List"
        />
      </div>
    );
  }

  async NavigateToProduct(data) {
    await Api_DrawAnalyticalPath(7, data.CATID);
    let rs = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
    rs.CATID = data.CATID;
    await set_dto_selected_merchant_or_product(rs);
    dto_selected_merchant_or_product.CATID = data.CATID;
    if (dto_selected_merchant_or_product.MT === "AF") {
      dto_selected_merchant_or_product.MT = "AF";
    } else {
      dto_selected_merchant_or_product.MT = "GR";
    }

    if (
      data.CATID === 1 &&
      data.MACID === 1 &&
      data.Category === "OFFER" &&
      CSP === "MK"
    ) {
      this.props.navigate(PT_PROMO_PRODUCT_LIST.replace(":navPage", "none"));
    } else {
      this.props.navigate(
        PT_PRODUCT_LIST.replace(":navPage", "none").replace(":isSec", "false")
      );
    }
  }
}
